import React from 'react'
import styles from './UploadLogo.module.scss'

const UploadLogo = ({ label = 'Upload logo', onChange }) => {
	return (
		<label className={styles.uploadBox}>
			<input
				type="file"
				accept=".jpg, .png"
				onChange={onChange}
				className={styles.hiddenInput}
			/>
			<div className={styles.content}>
				<img src="/images/UploadLogo.svg" alt="upload" />
				<span>{label}</span>
			</div>
		</label>
	)
}

export default UploadLogo
